import request from './request';

// 活动获取可用优惠券列表
export function getUsableCoupon(params) {
    return request('/coupon/usable/list', {
        method: 'GET',
        params,
    });
}

// 获取注册客户数
export function getRegisterCustomer(params) {
    return request('/activity/count/register-customer', {
        method: 'POST',
        params,
    });
}

// 手机号上传
export function uploadPhone(params) {
    return request('/activity/upload/phone', {
        method: 'POST',
        params,
        headers: {
            'Content-Type': 'multipart/form-data',
            // 是否取消统一报错提示
            'Cancel-Message': true,
        },
    });
}

// 车架号上传
export function uploadVin(params) {
    return request('/activity/upload/vin', {
        method: 'POST',
        params,
        headers: {
            'Content-Type': 'multipart/form-data',
            // 是否取消统一报错提示
            'Cancel-Message': true,
        },
    });
}

// 创建活动
export function createActivity(params) {
    return request('/activity/create', {
        method: 'POST',
        params,
    });
}
// 创建券、券包活动
export function createActivityOfCoupon(params) {
    return request('/activity/coupon/create', {
        method: 'POST',
        params,
    });
}

// 创建活动标签
export function createActivityLabel(params) {
    return request('/activity/label', {
        method: 'POST',
        params,
    });
}

// 获取活动标签
export function getActivityLabel(params) {
    return request('/activity/label', {
        method: 'GET',
        params,
    });
}

// 获取参与者信息
export function getActivityParticipant(params) {
    return request('/activity/detail/participant', {
        method: 'POST',
        params,
    });
}

// 获取操作记录
export function getOperationLog(id, params) {
    return request(`/activity/operationLog/${id}`, {
        method: 'GET',
        params,
    });
}

// 分页获取活动列表
export function getActivityList(params) {
    return request('/activity/list', {
        method: 'POST',
        params,
    });
}

// 获取活动列表(绑定广告用)
export function getAdvertActivity() {
    return request('/activity/advert-used/list', {
        method: 'POST',
    });
}

// 关闭活动
export function closeActivity(params) {
    return request(`/activity/close/${params.id}`, {
        method: 'PATCH',
        params,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
}

// 获取活动详情
export function getActivityDetail(params) {
    return request(`/activity/detail/${params}`, {
        method: 'GET',
        params,
    });
}

// 编辑活动
export function updateActivity(params) {
    return request('/activity/update', {
        method: 'PUT',
        params,
    });
}

// 编辑活动参与门店
export function updateActivityOrg(params) {
    return request('/activity/org/update', {
        method: 'PUT',
        params,
    });
}

// 获取活动参与门店
export function getActivityOrg(id) {
    return request(`/activity/activity-org/${id}`, {
        method: 'GET',
    });
}

// 根据标签id计算满足条件的客户总数
export function getTagCustomer(params) {
    return request('activity/tag/customer', {
        method: 'POST',
        params,
    });
}

// 快速创建活动
export function fastCreate(params) {
    return request('/activity/fast-create', {
        method: 'POST',
        params,
        headers: {
            // 是否取消统一报错提示
            'Cancel-Message': true,
        },
    });
}
// 获取活动统计概况及明细
export function getActivityStat(id, params) {
    return request(`/activity/stats/overview/${id}`, {
        method: 'POST',
        params,
    });
}
// 重试异步发放优惠券
export function activityRetry(id) {
    return request(`/activity/coupon/retry/${id}`, {
        method: 'POST',
    });
}
// 取消异步发放失败的优惠券
export function activityCancel(id) {
    return request(`/activity/cancel/${id}`, {
        method: 'POST',
    });
}
